<template>
  <v-dialog v-model="dialog" @click:outside="$emit('close')" @keyup.esc.stop="$emit('close')">
    <v-card>
      <v-card-title class="grey lighten-3 headline text-break">
        Applied Model Groups
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-2 px-4">
        <slot name="body"></slot>
        <v-container fluid class="pa-0">
          <v-data-table
            dense
            :headers="appliedModelsDatatable.headers"
            :items="appliedModelsDatatable.items"
            :loading="appliedModelsDatatable.loading"
            sort-by="modelCluster"
          >
            <template v-slot:item.actions="{ item }" >
              <v-btn v-if="readonly" icon @click.stop="openAppliedModel(item)">
                <v-icon class="mr-2"> mdi-eye </v-icon>
              </v-btn>
              <v-btn v-if="!readonly" icon @click.stop="editAppliedModel(item)">
                <v-icon class="mr-2"> mdi-pencil </v-icon>
              </v-btn>
              <v-btn v-if="!readonly"
                icon
                color="red"
                @click.stop="deleteAppliedModel(item)"
              >
                <v-icon class="mr-2"> mdi-delete </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn
          v-if="!readonly"
          @click="newAppliedModel"
          color="primary lighten-1"
          min-width="250"
        >
          Add new model group
        </v-btn>
        <v-btn
          @click="$emit('close')"
          color="primary lighten-1"
          outlined
          min-width="250"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>

    <AppliedModelEditDialog
      v-if="appliedModelsDatatable.editDialog"
      :esvId="esvId"
      :esv="esv"
      :dialog="appliedModelsDatatable.editDialog"
      :title="appliedModelsDatatable.editDialogTitle"
      :model="appliedModelsDatatable.editModel"
      :readonly="appliedModelsDatatable.readonly"
      :forceRefresh="forceRefresh"
      @close="appliedModelsDatatable.editDialog = false"
      @updated="appliedModelUpdated"
      ref="appliedModelEdit"
    />
  </v-dialog>
</template>

<script>
// @ is an alias to /src

export default {
  name: "DetailsAppliedModel",
  components: {
    // EditDialog,
    AppliedModelEditDialog: () =>
      import("@/components/AppliedModel/EditDialog"),
  },
  props: {
    esvId: Number,
    esv: Object,
    dialog: Boolean,
    readonly: Boolean,
  },
  data: () => ({
    appliedModelsDatatable: {
      editModel: {},
      editDialog: false,
      editDialogTitle: "Add item",
      items: [],
      headers: [
        { text: "Model Cluster", value: "modelCluster" },
        { text: "Countermeasure", value: "countermeasure" },
        { text: "Labour Cost", value: "labourCost" },
        { text: "Claim Reference", value: "claimReference" },
        { text: "Models", value: "models" },
        { text: "Parts", value: "parts" },
        { text: "Actions", value: "actions" },
      ],
      loading: false
    },
    forceRefresh: 0
  }),

  methods: {
    getAppliedModels() {
      this.appliedModelsDatatable.loading = true;
      this.$api.getAppliedModels(this.esvId)
        .then((resp) => {
          this.appliedModelsDatatable.items = resp.data.items;
        })
        .finally(() => {
          this.appliedModelsDatatable.loading = false;
        });
    },

    openAppliedModel(appliedModel) {
      this.$api.getAppliedModel(appliedModel.id).then((resp) => {
        this.appliedModelsDatatable.editModel = resp.data;
        this.appliedModelsDatatable.editDialog = true;
        this.appliedModelsDatatable.editDialogTitle = "Details Model Group";
        this.appliedModelsDatatable.readonly = true;
      });
    },

    editAppliedModel(appliedModel) {
      this.$api.getAppliedModel(appliedModel.id).then((resp) => {
        this.appliedModelsDatatable.editModel = resp.data;
        this.appliedModelsDatatable.editDialog = true;
        this.appliedModelsDatatable.editDialogTitle = "Update Model Group";
        this.appliedModelsDatatable.readonly = false;
      });
    },
    newAppliedModel() {
      this.appliedModelsDatatable.editModel = { currencyId: 1 };
      this.appliedModelsDatatable.editDialog = true;
      this.appliedModelsDatatable.editDialogTitle = "Create Model Group";
      this.appliedModelsDatatable.readonly = false;
      this.forceRefresh++; 
    },
    appliedModelUpdated(close) {
      this.getAppliedModels();
      this.$emit("updated");
      if (close) {
        this.appliedModelsDatatable.editDialog = false;  
      }
      
    },
    deleteAppliedModel(appliedModel) {
      this.$confirm('Arey you sure you want to delete this item?')
        .then(res => {
          if (res) {
            this.$api
              .deleteAppliedModel(appliedModel.id)
              .then(() => {
                this.getAppliedModels();
                this.$toast.success("Changes have been saved");
                this.$emit("deleted");
              });
          }
        })

    }
  },

  mounted() {
    // this.getAppliedModels();
  },
  watch: {
    dialog: {
      handler() {
        if (this.dialog) {
          this.getAppliedModels();
        }
      },
    },
  },
};
</script>
